<template>
  <NewsList endpoint="collaborator" />
</template>
<script>
import NewsList from "@/components/NewsList";

export default {
  components: {
    NewsList
  }
};
</script>
